import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { getBankAccountsForNominee } from 'lib/api';
import {
  getPaymentRequestPassive,
  postPayoutsForPaymentRequestPassive,
} from 'lib/api/paymentRequestPassives';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTable from 'lib/designSystem/Table';
import { PaymentRequestPassive } from 'lib/types/models';
import GenerateNominee from 'pages/Finance/Components/Financing/Factoring/components/Recieved/components/ShoppingDialog/components/PaymentModule/components/generateNominee';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const nomineeHeaders = [
  { key: 'bankAccountOriginName', label: 'Banco origen' },
  {
    key: 'bankAccountDestinationName',
    label: 'Banco destino',
  },
  { key: 'bankAccountDestinationNumber', label: 'N° Cuenta' },
  { key: 'bankAccountDestinationAccountType', label: 'Tipo de cuenta' },
  { key: 'bankAccountDestinationHolderName', label: 'Titular' },
  { key: 'bankAccountDestinationHolderIdentifier', label: 'Rut' },
  { key: 'amount', label: 'Monto', type: 'money' },
  { key: 'executedAt', label: 'Ejecutada', type: 'date' },
];

interface GeneratePayoutStepProps {
  stepBack: () => void;
  nextStep: () => void;
  selectedRequest: number | null;
  setFailureOpen: (message: string) => void;
}

function GeneratePayoutStep({
  stepBack,
  nextStep,
  selectedRequest,
  setFailureOpen,
}: GeneratePayoutStepProps) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [paymentRequestPassive, setPaymentRequestPassive] =
    useState<PaymentRequestPassive | null>(null);

  const [destinyAccounts, setDestinyAccounts] = useState([]);
  const [originAccounts, setOriginAccounts] = useState([]);

  const [payments, setPayments] = useState([]);

  async function setUp() {
    setLoading(true);
    if (!selectedRequest) {
      setLoading(false);
      nextStep();
      return true;
    }
    try {
      const paymentRequestPassiveRequest = await getPaymentRequestPassive(
        dispatch,
        selectedRequest,
      );
      if (!paymentRequestPassiveRequest)
        throw 'Payment Request passive not found';

      setPaymentRequestPassive(paymentRequestPassiveRequest);
      const businessIdentifier =
        paymentRequestPassiveRequest.documentsToPay[0].document
          .businessIdentifier;
      const accounts = await getBankAccountsForNominee(
        dispatch,
        businessIdentifier,
      );
      if (accounts) {
        setDestinyAccounts(accounts.businessBankAccounts);
        setOriginAccounts(accounts.ownBankAccounts);
        setLoading(false);
        return true;
      }
    } catch (error) {
      console.error(error);
      setFailureOpen('Error al obtener las cuentas');
      setLoading(false);
      return false;
    }
  }

  async function handleSubmit() {
    if (!selectedRequest) return;
    setLoading(true);
    try {
      await postPayoutsForPaymentRequestPassive(dispatch, selectedRequest, {
        payments,
      });
    } catch (error) {
      console.error(error);
      setFailureOpen('Error al crear los pagos');
    }
    setLoading(false);
    void nextStep();
  }

  const isNextButtonDisabled = () => {
    if (paymentRequestPassive?.amount === 0) return false;

    if (payments.length === 0) return true;

    return false;
  };

  useEffect(() => {
    void setUp();
  }, []);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <DialogTitle>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6">Crear pagos</Typography>
        </div>
      </DialogTitle>
      <DialogContent style={{ padding: '0px 24px' }}>
        {paymentRequestPassive && payments.length === 0 && (
          <GenerateNominee
            availableAccounts={destinyAccounts}
            originAccounts={originAccounts}
            selectedRequest={selectedRequest}
            setPayments={setPayments}
            amount={paymentRequestPassive.amount}
          />
        )}
        {payments.length > 0 ? (
          <div>
            <Typography variant="body1" margin={'4px'}>
              Seleccione la configuración de pago
            </Typography>
            <EnhancedTable dataHeaders={nomineeHeaders} data={payments} />
          </div>
        ) : null}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={stepBack}>
          {' '}
          Cancelar{' '}
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleSubmit}
          disabled={isNextButtonDisabled()}
        >
          {' '}
          {'Crear'}{' '}
        </CustomButton>
      </DialogActions>
    </>
  );
}

export default GeneratePayoutStep;
